import { Component, input } from "@angular/core";

/**
 * The Taolo mark — bar, gap, offset stem. Geometry and usage rules live in
 * `docs/brand.md`; the SVG here is the same 64-unit grid as
 * `src/assets/brand/mark.svg`, inlined so it can take `currentColor`.
 *
 * There is deliberately no joined-stem fallback for small sizes. The split is
 * the identity and it is the only cut, so below roughly 20px the gap thins to
 * about a pixel — size callers accordingly rather than reaching for a variant
 * that does not exist.
 */
@Component({
  selector: "app-logo",
  standalone: true,
  templateUrl: "./logo.component.html",
})
export class LogoComponent {
  /** Rendered edge length in px. The mark is square. */
  size = input<number>(24);
}
